<!-- 定位组件 -->
<template>
  <div v-if="isLoading" class="loading" >
    <div>
      <van-loading color="#1989fa" type="spinner" vertical> 定位中... </van-loading>
    </div>
  </div>
</template>

<script>
import { getCurrentPosition, reverseGeocoder, DEFAULT_CITY } from '../../utils/TMapUtils.js';

export default {
  name: "LocationComponent",
  data() {
    return {
      isLoading: false,
      locationTimeout: null
    };
  },
  
  computed: {
    // 从Vuex获取当前地址
    currentAddress() {
      return this.$store.state.address;
    },
    // 从Vuex获取当前城市代码
    currentCityCode() {
      return this.$store.state.cityCode;
    }
  },
  
  async mounted() {
    // 如果已有地址和城市代码，不需要重新定位
    if (this.currentAddress && this.currentCityCode) {
      console.log('已有定位城市');
      // 即使已有信息，也需要触发位置完成事件
      this.$emit('location-finish', {
        address: this.currentAddress,
        cityCode: this.currentCityCode
      });
      return;
    }
    
    // 检查localStorage中是否有存储的值
    const storedAddress = localStorage.getItem("address");
    const storedCityCode = localStorage.getItem("cityCode");
    
    if (storedAddress && storedCityCode) {
      this.$store.commit("setAddress", storedAddress);
      this.$store.commit("setCityCode", storedCityCode);
      // 使用存储值时也触发位置完成事件
      this.$emit('location-finish', {
        address: storedAddress,
        cityCode: storedCityCode
      });
      return;
    }
    
    // 只有当没有地址信息时才进行定位
    await this.handleLocation();
  },
  
  beforeDestroy() {
    if (this.locationTimeout) {
      clearTimeout(this.locationTimeout);
    }
  },
  
  methods: {
    // 主要定位方法
    async handleLocation() {
      // 显示加载中状态
      this.isLoading = true;
      let success = false;
      
      try {
        // 整段定位 10 秒超时：取坐标、逆地理、查城市任一步不回调都能兜底
        const locateTask = (async () => {
          // 获取位置
          const position = await getCurrentPosition();
          //设置地理坐标
          if (position) {
            localStorage.setItem("latitude", position.lat);
            localStorage.setItem("longitude", position.lng);
          }
          // 获取地址信息
          const location = await reverseGeocoder(position);
          // 处理位置信息
          return await this.processLocationResult(location);
        })();
        success = await this.withTimeout(locateTask, 20000);
      } catch (error) {
        console.error('定位失败:', error);
        // 使用默认城市
        this.useDefaultCity();
      } finally {
        this.isLoading = false;
        // 如果上面流程都没成功，也兜底
        if (!success) this.useDefaultCity();
        // 定位成功或失败后
        this.$emit('location-finish', {
          address: this.$store.state.address,
          cityCode: this.$store.state.cityCode
        });
      }
    },

    withTimeout(promise, ms) {
      return new Promise((resolve, reject) => {
        // 清除可能存在的上一个超时定时器
        if (this.locationTimeout) {
          clearTimeout(this.locationTimeout);
        }
        this.locationTimeout = setTimeout(() => {
          reject(new Error('定位超时'));
        }, ms);
        promise.then(
          (value) => {
            clearTimeout(this.locationTimeout);
            resolve(value);
          },
          (error) => {
            clearTimeout(this.locationTimeout);
            reject(error);
          }
        );
      });
    },
    
    // 处理定位结果
    async processLocationResult(location) {
      if (!location || !location.addressComponent) {
        this.useDefaultCity();
        return false;
      }
      // 获取城市名称（直辖市可能没有city，使用province）
      const cityName = location.addressComponent.city || location.addressComponent.province;
      if (!cityName) {
        this.useDefaultCity();
        return false;
      }
      
      try {
        // 查询城市列表获取城市代码
        const res = await this.$api.queryCityList(cityName);
        if (res.data && res.data.length > 0) {
          // 提取地址信息
          const address = res.data[0].provinceName.replace("市", "");
          const cityCode = res.data[0].provinceId;
          // 保存到本地存储和Vuex
          localStorage.setItem("address", address);
          localStorage.setItem("cityCode", cityCode);
          this.$store.commit("setAddress", address);
          this.$store.commit("setCityCode", cityCode);
          return true;
        } else {
          this.useDefaultCity();
          return false;
        }
      } catch (error) {
        console.error('城市信息处理失败:', error);
        // 使用默认城市
        this.useDefaultCity();
        return false;
      }
    },
    
    // 使用默认城市
    useDefaultCity() {
      // 使用天地图工具类中的默认城市
      const address = DEFAULT_CITY.name;
      const cityCode = DEFAULT_CITY.code;
      
      localStorage.setItem("address", address);
      localStorage.setItem("cityCode", cityCode);
      this.$store.commit("setAddress", address);
      this.$store.commit("setCityCode", cityCode);
      
      // 提示用户
      this.$Toast && this.$Toast.fail("定位失败,默认北京市");
    }
  }
};
</script>

<style lang='scss' scoped>
.loading {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>